import {createSlice} from '@reduxjs/toolkit';
import {EcowittUserLink} from '../../api/types';

type Props = {
  link: EcowittUserLink | null;
};

export const ecowittSlice = createSlice({
  name: 'ecowitt',
  initialState: {
    link: null,
  } as Props,
  reducers: {
    setEcowittUserLink: (
      state,
      {payload: link}: {payload: EcowittUserLink},
    ) => {
      if (state.link === null || link === null) {
        state.link = link;
      } else {
        // mergeDeep in order to keep generic_station key which is not present for station list
        const oldWeatherStations = state.link.account.weather_stations;
        const newWeatherStations = link.account.weather_stations;

        state.link = link;
        const mergedWeatherStations = [];
        newWeatherStations.forEach((newItem) => {
          const oldStation = oldWeatherStations.find(
            (oldItem) => oldItem.device_id === newItem.device_id,
          );
          if (oldStation) {
            mergedWeatherStations.push({...oldStation, ...newItem});
          } else {
            mergedWeatherStations.push(newItem);
          }
        });
        state.link.account.weather_stations = mergedWeatherStations;
      }
    },
  },
});

export const {setEcowittUserLink} = ecowittSlice.actions;

export default ecowittSlice.reducer;
